import React from "react";
import { Container, Paper } from "@mui/material";
import BaseOrgChartView from "../Views/BaseOrgChartView";

const ExtrasOrgChartView = () => {
  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4, px: { xs: 2, md: 4 } }}>
      <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3, bgcolor: '#f8fafd', minHeight: '85vh' }}>
        <BaseOrgChartView
          chartType="EXTRAS"
          title="Organigrama de Extras"
          description="Consulta la estructura de extras de forma clara y rapida."
          showFilters={false}
          displayMode="extras"
        />
      </Paper>
    </Container>
  );
};

export default ExtrasOrgChartView;